import { useContext } from "react";

import { AudioContext, type AudioContextValue } from "./context";

export function useAudio(): AudioContextValue {
  const audio = useContext(AudioContext);
  if (!audio) {
    throw new Error("useAudio must be used within an AudioProvider");
  }

  return audio;
}
